var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _ellipse, _linearGradient5, _circle, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CarService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MMnL7286lCDyOBPIL8VQ8a",
    x1: 22.644,
    x2: 22.644,
    y1: 8.286,
    y2: 44.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082db"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MMnL7286lCDyOBPIL8VQ8a)",
    d: "M45.29,18.94c-0.15,0.23-0.32,0.45-0.5,0.66c-0.23,0.28-0.47,0.54-0.72,0.78 c-0.91,0.89-1.95,1.57-3.07,2.04V33H3.7c-0.65,0-1.64-0.34-2.46-0.68c-0.83-0.34-1.33-1.21-1.23-2.12l0.63-5.79 c0.13-1.17,0.9-2.16,1.98-2.55l9.07-3.3l5.43-4.99c1.1-1.01,2.53-1.57,4.01-1.57h11.99c0.19,0.79,0.61,1.48,1.19,2 c0.7,0.62,1.64,1,2.69,1c0.4,0,0.78-0.05,1.14-0.16c0.45-0.13,0.87-0.33,1.23-0.59l2.21,3L45.29,18.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#53616a",
    d: "M4,33.5C4,31.015,6.015,29,8.5,29s4.5,2.015,4.5,4.5S10.985,38,8.5,38S4,35.985,4,33.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M6.7,33.5c0-0.994,0.806-1.8,1.8-1.8s1.8,0.806,1.8,1.8s-0.806,1.8-1.8,1.8S6.7,34.494,6.7,33.5"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MMnL7286lCDyOBPIL8VQ8b",
    x1: 36.986,
    x2: 37.038,
    y1: 44.972,
    y2: 22.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#9eabb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#9ba8b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    stopColor: "#919da6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#818c93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768085"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MMnL7286lCDyOBPIL8VQ8b)",
    d: "M43,39c0,0.93-0.21,1.8-0.59,2.58C41.45,43.6,39.39,45,37,45s-4.45-1.4-5.41-3.42 C31.21,40.8,31,39.93,31,39c0-1.09,0.29-2.12,0.81-3c0.31-0.55,0.72-1.04,1.19-1.46V21h8v13.54c0.47,0.42,0.88,0.91,1.19,1.46 C42.71,36.88,43,37.91,43,39z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MMnL7286lCDyOBPIL8VQ8c",
    x1: 29.91,
    x2: 43.718,
    y1: 20.538,
    y2: 6.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9eabb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c979f"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MMnL7286lCDyOBPIL8VQ8c)",
    d: "M45.29,18.94c-0.15,0.23-0.32,0.45-0.5,0.66c-0.23,0.28-0.47,0.54-0.72,0.78 c-0.91,0.89-1.95,1.57-3.07,2.04c-2.54,1.09-5.45,1.09-8,0c-1.42-0.6-2.73-1.54-3.79-2.82c-1.35-1.62-2.08-3.58-2.19-5.6 c-0.04-0.67-0.01-1.34,0.09-2c0.22-1.44,0.76-2.84,1.63-4.08c0.84-1.21,1.89-2.14,3.05-2.82C32.26,4.82,33,5.46,33,6v5 c0,0.35,0.04,0.68,0.12,1c0.19,0.79,0.61,1.48,1.19,2c0.7,0.62,1.64,1,2.69,1c0.4,0,0.78-0.05,1.14-0.16 c0.45-0.13,0.87-0.33,1.23-0.59C40.38,13.54,41,12.36,41,11V6c0-0.54,0.74-1.18,1.21-0.9c1.16,0.68,2.21,1.61,3.05,2.82 C47.57,11.23,47.57,15.66,45.29,18.94z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MMnL7286lCDyOBPIL8VQ8d",
    x1: 40.839,
    x2: 35.232,
    y1: 410.825,
    y2: 416.432,
    gradientTransform: "scale(1 -1) rotate(45 583.99 186.002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37,
    cy: 39.087,
    fill: "url(#MMnL7286lCDyOBPIL8VQ8d)",
    rx: 4,
    ry: 3.913
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MMnL7286lCDyOBPIL8VQ8e",
    x1: 36.234,
    x2: 39.516,
    y1: 415.552,
    y2: 412.27,
    gradientTransform: "scale(1 -1) rotate(45 583.99 186.002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0061ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#005fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#005698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00518e"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 39,
    r: 2,
    fill: "url(#MMnL7286lCDyOBPIL8VQ8e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1b",
    d: "M29.21,19.6c-1.35-1.62-2.08-3.58-2.19-5.6c-0.04-0.67-0.01-1.34,0.09-2H25.1 c-0.1,0.7-0.12,1.41-0.08,2.12c0.14,2.5,1.06,4.84,2.65,6.76C28.6,22,29.73,22.95,31,23.66V33h2V22.42 C31.58,21.82,30.27,20.88,29.21,19.6z",
    opacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1b",
    d: "M29.21,19.6c-1.35-1.62-2.08-3.58-2.19-5.6c-0.04-0.67-0.01-1.34,0.09-2H26.1 c-0.09,0.68-0.12,1.37-0.08,2.06c0.13,2.29,0.96,4.43,2.42,6.18c0.97,1.17,2.2,2.14,3.56,2.82V33h1V22.42 C31.58,21.82,30.27,20.88,29.21,19.6z",
    opacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CarService);
export default __webpack_public_path__ + "static/media/icons8-car-service.edeb965e1e1308547f12b089c3932962.svg";
export { ForwardRef as ReactComponent };